import {getMethod, postMethod, putMethod} from '~/api'

async function get(packageId, request) {
    return await getMethod(`/api/ownPackageContracts/${packageId}/itineraryDay`, request)
}

async function post(packageId, request) {
    return await postMethod(`/api/ownPackageContracts/${packageId}/itineraryDay`, request)
}

async function put(packageId, request) {
    return await putMethod(`/api/ownPackageContracts/${packageId}/itineraryDay`, request)
}

export {get, post, put}
